import React from "react";
import { useAuth } from "../../context/AuthContext";
import { useI18n } from "../../i18n/I18nContext";
import { useSeo } from "../../components/SEO";
import { Button } from "../../components/ui/button";
import { ShieldCheck, LogIn } from "lucide-react";

export default function AdminLogin() {
  const { t } = useI18n();
  const { user, loading } = useAuth();
  useSeo(t("admin.login"));

  const startLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F9F6F0] px-5">
      <div className="w-full max-w-md rounded-3xl border border-black/5 bg-white p-8 text-center shadow-lg" data-testid="admin-login">
        <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#1E293B]">
          <ShieldCheck className="h-7 w-7 text-white" />
        </span>
        <h1 className="mt-5 font-display text-3xl">{t("admin.login")}</h1>
        <p className="mt-2 text-[15px] text-[#5C6370]">{t("admin.loginNotice")}</p>
        {user && user.role !== "admin" && (
          <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700" data-testid="admin-no-access">{t("admin.noAccess")}</p>
        )}
        <Button onClick={startLogin} disabled={loading} data-testid="google-login-button"
          className="mt-6 w-full rounded-full min-h-[48px] bg-[#1E293B] hover:bg-[#0f172a]">
          <LogIn className="mr-2 h-5 w-5" /> {t("admin.loginGoogle")}
        </Button>
        <a href="/" className="mt-4 inline-block text-sm text-[#2A9D8F] hover:underline">← {t("common.backHome")}</a>
      </div>
    </div>
  );
}
